import React from 'react';
import { useIntl } from 'react-intl-next';
import { selectionToolbarMessages } from '@atlaskit/editor-common/messages';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { PinnedIcon, ToolbarButton, ToolbarTooltip } from '@atlaskit/editor-toolbar';
import { fg } from '@atlaskit/platform-feature-flags';
export var PinButton = function PinButton(_ref) {
  var api = _ref.api;
  var intl = useIntl();
  var message = intl.formatMessage(selectionToolbarMessages.toolbarPositionPinedAtTop);
  var _useEditorToolbar = useEditorToolbar(),
    isOffline = _useEditorToolbar.isOffline;
  var isDisabled = fg('platform_editor_toolbar_aifc_patch_7') ? isOffline : false;
  var onClick = function onClick() {
    var _api$selectionToolbar, _api$selectionToolbar2;
    if (!api || isDisabled) {
      return;
    }
    if (fg('platform_editor_migrate_toolbar_docking')) {
      var _api$userPreferences;
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.actions.updateUserPreference('toolbarDockingPosition', 'none'));
      return;
    }
    (_api$selectionToolbar = api.selectionToolbar.actions) === null || _api$selectionToolbar === void 0 || (_api$selectionToolbar2 = _api$selectionToolbar.setToolbarDocking) === null || _api$selectionToolbar2 === void 0 || _api$selectionToolbar2.call(_api$selectionToolbar, 'none');
  };
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: message
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: /*#__PURE__*/React.createElement(PinnedIcon, {
      size: "small",
      label: ""
    }),
    label: message,
    onClick: onClick,
    isDisabled: isDisabled
  }));
};